
import { FileText, Loader2 } from "lucide-react";

interface DocumentLoadingProps {
  message?: string;
}

export function DocumentLoading({ message = "Loading documents..." }: DocumentLoadingProps) {
  return (
    <div className="flex justify-center items-center p-8">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

export function DocumentEmpty() {
  return (
    <div className="text-center py-8 text-muted-foreground">
      <FileText className="mx-auto h-12 w-12 opacity-20 mb-2" />
      <p>No documents uploaded yet</p>
    </div>
  );
}
